import React, { Fragment } from 'react';

export default function LivePreviewExample() {
  return (
    <Fragment>
      <span className="btn-pill m-1 badge badge-primary">Primary</span>
      <span className="btn-pill m-1 badge badge-second">Secondary</span>
      <span className="btn-pill m-1 badge badge-success">Success</span>
      <span className="btn-pill m-1 badge badge-danger">Danger</span>
      <span className="btn-pill m-1 badge badge-warning">Warning</span>
      <span className="btn-pill m-1 badge badge-info">Info</span>
      <span className="btn-pill m-1 badge badge-dark">Dark</span>
    </Fragment>
  );
}
